"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5639],{

/***/ 35639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AuthContext": function() { return /* binding */ AuthContext; },
  "AuthProvider": function() { return /* binding */ AuthProvider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/configs/auth.js
/* harmony default export */ var auth = ({
    meEndpoint: "/auth/me",
    loginEndpoint: "/jwt/login",
    registerEndpoint: "/jwt/register",
    storageTokenKeyName: "accessToken",
    onTokenExpiration: "refreshToken" // logout | refreshToken
});

// EXTERNAL MODULE: ./src/utils/navigate.js
var utils_navigate = __webpack_require__(48551);
// EXTERNAL MODULE: ./src/utils/subscriptionExpire.js
var subscriptionExpire = __webpack_require__(96613);
// EXTERNAL MODULE: ./src/utils/resolveCurrentOrderId.js
var resolveCurrentOrderId = __webpack_require__(32870);
// EXTERNAL MODULE: ./src/utils/subscriptionStatus.js
var subscriptionStatus = __webpack_require__(38365);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
;// CONCATENATED MODULE: ./src/context/AuthContext.js
// ** React Imports


// ** Next Import

// ** Axios

// ** Config





const bUrl = (/* unused pure expression or super */ null && ("https://test-ms-service.gbyte.com.cn"));
const clientURL = "https://test-ms-web.gbyte.com.cn";
// ** Defaults
const defaultProvider = {
    user: null,
    loading: true,
    setUser: ()=>null,
    setLoading: ()=>Boolean,
    login: ()=>Promise.resolve(),
    logout: ()=>Promise.resolve(),
    register: ()=>Promise.resolve()
};
const AuthContext = /*#__PURE__*/ (0,react.createContext)(defaultProvider);
// request

const getParams = (url)=>{
    try {
        url = url.match(/\?([^#]+)/)[1];
        const obj = {};
        const arr = url.split("&");
        for(let i = 0; i < arr.length; i++){
            let subArr = arr[i].split("=");
            let key = decodeURIComponent(subArr[0]);
            let value = decodeURIComponent(subArr[1]);
            obj[key] = value;
        }
        return obj;
    } catch (err) {
        return null;
    }
};
const readJson = (key, fallback)=>{
    try {
        const raw = localStorage.getItem(key);
        if (raw == null || raw === "") return fallback;
        return JSON.parse(raw);
    } catch (e) {
        return fallback;
    }
};
const AuthProvider = (param)=>{
    let { children  } = param;
    // ** States
    const [user, setUser] = (0,react.useState)(defaultProvider.user);
    const [loading, setLoading] = (0,react.useState)(defaultProvider.loading);
    // ** Hooks
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const initAuth = async ()=>{
            try {
                const urlParams = getParams(location.search);
                let accessToken = window.localStorage.getItem(auth.storageTokenKeyName);
                if (urlParams != null) {
                    // 退出登录
                    if (urlParams.accessToken == "clear") {
                        window.localStorage.removeItem("userData");
                        window.localStorage.removeItem(auth.storageTokenKeyName);
                        localStorage.removeItem("Basic");
                        localStorage.removeItem("Advanced");
                        localStorage.removeItem("DeviceUser");
                        localStorage.removeItem("currentDevice", JSON.stringify({}));
                        (0,utils_navigate/* replaceWith */.dL)("".concat(clientURL, "/login?q=clear"));
                        return;
                    }
                    if (urlParams.accessToken && urlParams.accessToken != accessToken) {
                        localStorage.setItem("Basic", 0);
                        localStorage.setItem("Advanced", 0);
                        localStorage.setItem("DeviceUser", JSON.stringify({}));
                        localStorage.setItem("currentDevice", JSON.stringify({}));
                        window.localStorage.setItem(auth.storageTokenKeyName, urlParams.accessToken);
                    }
                } else if (accessToken == null) {
                    if (window.location.pathname.substring(1) === "user-guide-ios" || window.location.pathname.substring(1) === "user-guide-android" || window.location.pathname.substring(4) === "user-guide-ios" || window.location.pathname.substring(4) === "user-guide-android" || window.location.pathname.substring(1) === "back-up-android" || window.location.pathname.substring(1) === "back-up-ios" || window.location.pathname.substring(4) === "back-up-ios" || window.location.pathname.substring(4) === "back-up-android") {
                        (0,utils_navigate/* replaceWith */.dL)("".concat(clientURL, "/login?guide=").concat(encodeURIComponent("".concat(window.location.origin).concat(router.asPath))));
                        return;
                    }
                    (0,utils_navigate/* replaceWith */.dL)("".concat(clientURL, "/login"));
                }
                let token = window.localStorage.getItem(auth.storageTokenKeyName);
                if (!token) return;
                let user = await (0,login.getUserInfo)();
                let currentMode = localStorage.getItem("currentMode") || "";
                if (urlParams == null) {
                    try {
                        let { all , data  } = await (0,login.userDeviceCurrent)();
                        // 新号常见 { data: null, all: [null] }：有未绑定订单但 platform_type 为空。
                        // data != '' 对 null 仍为 true，会把 currentMode 设成 null，随后 indexOf 抛错卡死登录
                        // （main 的 14c20bc 修的就是这个；合并时把它并进本分支的重构版本）。
                        const modes = (Array.isArray(all) ? all : []).filter((m)=>m != null && m !== "");
                        const mode = data == null || data === "" ? "" : String(data);
                        if (mode) {
                            if (modes.length >= 2 && localStorage.getItem("currentMode") != null) {
                                currentMode = localStorage.getItem("currentMode") || "";
                            } else {
                                currentMode = mode;
                                window.localStorage.setItem("currentMode", mode);
                            }
                        }
                    } catch (e) {
                        ;
                    }
                }
                let requestMode = currentMode;
                if (currentMode.indexOf("Android") >= 0) {
                    requestMode = "Android";
                }
                // user-device 偶发 500 时绝不能抛穿：否则 loading 永不结束，AuthGuard 永久转圈（表现为卡死）
                let deviceList = [];
                let deviceFetchFailed = false;
                try {
                    const query = requestMode ? {
                        platform_type: requestMode
                    } : {};
                    const allUserDevice = await (0,login.getAllUserDevice)(query);
                    deviceList = Array.isArray(allUserDevice === null || allUserDevice === void 0 ? void 0 : allUserDevice.data) ? allUserDevice.data : [];
                } catch (e1) {
                    deviceFetchFailed = true;
                    ;
                    const cached = readJson("allDeviceUser", []);
                    deviceList = Array.isArray(cached) ? cached : [];
                }
                if (deviceList.length > 0) {
                    var ref, ref1;
                    // 当前设备：优先按 id 匹配。同一个 iCloud 邮箱可以绑多台设备，
                    // 只按 platform_type 取第一个会在刷新时选错账号（侧栏出现两个选中态）。
                    const pickId = function() {
                        for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++){
                            values[_key] = arguments[_key];
                        }
                        for (const value of values){
                            const id = value == null ? "" : String(value).trim();
                            if (id !== "" && !id.includes("@")) return id;
                        }
                        return "";
                    };
                    const previousDeviceUser = readJson("DeviceUser", null) || {};
                    const previousCurrentDevice = readJson("currentDevice", null) || {};
                    const preferredId = pickId(previousDeviceUser === null || previousDeviceUser === void 0 ? void 0 : previousDeviceUser.device_id, previousDeviceUser === null || previousDeviceUser === void 0 ? void 0 : previousDeviceUser.id, previousCurrentDevice === null || previousCurrentDevice === void 0 ? void 0 : (ref = previousCurrentDevice.DeviceUser) === null || ref === void 0 ? void 0 : ref.device_id, previousCurrentDevice === null || previousCurrentDevice === void 0 ? void 0 : (ref1 = previousCurrentDevice.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.id);
                    var _id, ref2;
                    const deviceIdOf = (row)=>row == null ? "" : String((ref2 = (_id = row.id) !== null && _id !== void 0 ? _id : row.device_id) !== null && ref2 !== void 0 ? ref2 : "").trim();
                    let getCurrentDev = (preferredId ? deviceList.find((row)=>{
                        return deviceIdOf(row) === preferredId && (!currentMode || (row === null || row === void 0 ? void 0 : row.platform_type) === currentMode);
                    }) : null) || deviceList.find((row)=>row.platform_type == currentMode);
                    let currentDevice = readJson("currentDevice", null) || "";
                    if (currentMode == "Android-Local" && currentDevice) {
                        let find = deviceList.find((row)=>row.platform_type == currentMode && row.iCloud_username == currentDevice.id);
                        if (find) {
                            getCurrentDev = find;
                        }
                    }
                    // 与 SpyX 一致：只恢复仍可选（active/grace）的设备，永不自动选中超 30 天失效设备。
                    // 上次用的设备若已过期超 30 天，先回退到同平台其它可选设备；一个都没有则清空选中，
                    // 避免出现「侧栏列表里已隐藏、却仍是当前设备」的幽灵选中态。
                    if (getCurrentDev && !(0,subscriptionStatus/* isSelectableDevice */.He)(getCurrentDev)) {
                        getCurrentDev = (0,subscriptionStatus/* pickPreferredSelectableDevice */.oT)(deviceList, currentMode) || null;
                        if (!getCurrentDev) {
                            localStorage.setItem("DeviceUser", JSON.stringify({}));
                        }
                    }
                    if (getCurrentDev && !(0,resolveCurrentOrderId/* isUnboundPackageSelectionActive */.gJ)()) {
                        // 必须写完整字段（含 device_id）：漏掉 device_id 后所有「按 id 找当前设备」
                        // 的逻辑只能退回用邮箱反查，同邮箱多账号就会串号。
                        // 但侧栏已选中「未绑定的 Package」时不能覆盖：否则刷新后 Package 卡与账号卡
                        // 会同时是选中态，功能菜单也会莫名冒出来。
                        localStorage.setItem("DeviceUser", JSON.stringify((0,subscriptionExpire/* buildDeviceUserPayload */.l)(getCurrentDev)));
                    }
                    const deviceUser = readJson("DeviceUser", {}) || {};
                    if (!deviceUser.username || !deviceUser.password) {
                        localStorage.setItem("Basic", 0);
                    } else {
                        localStorage.setItem("Basic", 1);
                    }
                    localStorage.setItem("BasicTips", 1);
                    localStorage.setItem("Advanced", 1);
                    localStorage.setItem("allDeviceUser", JSON.stringify(deviceList));
                } else if (!deviceFetchFailed) {
                    // 接口成功但无设备：才清本地标记。接口失败时保留原状态，避免偶发 500 把用户打回未绑定。
                    localStorage.setItem("BasicTips", 0);
                    localStorage.setItem("Basic", 0);
                    localStorage.setItem("Advanced", 0);
                    localStorage.setItem("allDeviceUser", JSON.stringify([]));
                }
                user.role = "admin";
                setUser(user);
                window.localStorage.setItem("userData", JSON.stringify(user));
            } catch (e2) {
                ;
                // getUserInfo 等关键路径失败时，尽量用本地缓存顶住，避免 AuthGuard 永久转圈
                const cachedUser = readJson("userData", null);
                if (cachedUser && typeof cachedUser === "object") {
                    cachedUser.role = cachedUser.role || "admin";
                    setUser(cachedUser);
                }
            } finally{
                setLoading(false);
            }
        };
        initAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleLogin = (params, errorCallback)=>{};
    const handleLogout = ()=>{
        setUser(null);
        window.localStorage.removeItem("userData");
        window.localStorage.removeItem(auth.storageTokenKeyName);
        localStorage.removeItem("Basic");
        localStorage.removeItem("Advanced");
        localStorage.removeItem("DeviceUser");
        localStorage.removeItem("currentDevice", JSON.stringify({}));
        (0,utils_navigate/* replaceWith */.dL)("".concat(clientURL, "/login?q=clear"));
    };
    const values = {
        user,
        loading,
        setUser,
        setLoading,
        login: handleLogin,
        logout: handleLogout
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContext.Provider, {
        value: values,
        children: children
    });
};



/***/ }),

/***/ 96613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ parseExpireMs; },
/* harmony export */   "Jn": function() { return /* binding */ THIRTY_DAYS_MS; },
/* harmony export */   "ku": function() { return /* binding */ resolveDeviceExpireTime; },
/* harmony export */   "l": function() { return /* binding */ buildDeviceUserPayload; }
/* harmony export */ });
/* unused harmony exports isSubscriptionActive, isDeviceActive, isExpiredPastGracePeriod, areAllDevicesExpiredPastGrace, isDeviceWithinGracePeriod, shouldShowExpiredMask, pickFirstActiveDevice */
/**
 * 解析 expire_time 为 UTC 毫秒时间戳。
 * ISO 8601 带 Z（如 2026-11-16T07:35:07.623Z）会被正确解析为绝对时刻，与用户本地时区无关。
 */ const parseExpireMs = (raw)=>{
    if (raw == null || raw === "") return NaN;
    const ms = new Date(raw).getTime();
    return Number.isFinite(ms) ? ms : NaN;
};
/** 订阅仍有效：无 expire_time 视为有效；否则 expire_time >= 当前时刻 */ const isSubscriptionActive = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    return ms >= now;
};
const isDeviceActive = (device)=>{
    return isSubscriptionActive(device === null || device === void 0 ? void 0 : device.expire_time);
};
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
/** 已过期且超过宽限期（默认 30 天） */ const isExpiredPastGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return false;
    if (ms >= now) return false;
    return now - ms > graceMs;
};
/** 全部设备均已过期且超过宽限期 */ const areAllDevicesExpiredPastGrace = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>{
        return isExpiredPastGracePeriod(device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
    });
};
/** 从侧栏设备项（数组或单条记录）解析 expire_time */ const resolveDeviceExpireTime = (item)=>{
    var ref, ref1, ref2;
    if (!item) return null;
    if (item.expire_time != null && item.expire_time !== "") return item.expire_time;
    if (Array.isArray(item) && ((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.expire_time)) return item[0].DeviceUser.expire_time;
    if (item === null || item === void 0 ? void 0 : (ref2 = item.DeviceUser) === null || ref2 === void 0 ? void 0 : ref2.expire_time) return item.DeviceUser.expire_time;
    return null;
};
/** 侧栏仍展示：未过期、无 expire_time、或过期未超过 graceDays（默认 30 天） */ const isDeviceWithinGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    if (ms >= now) return true;
    return now - ms <= graceMs;
};
/** Feature 详情页遮罩：已过期且在宽限期内（默认 30 天） */ const shouldShowExpiredMask = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return !isSubscriptionActive(expireTime, now) && isDeviceWithinGracePeriod(expireTime, now, graceMs);
};
/** 取第一个可选中设备：优先未过期(active)，其次宽限期(grace)；永不返回超 30 天失效 */ const pickFirstActiveDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const now = Date.now();
    const selectable = scoped.filter((item)=>{
        const ms = parseExpireMs(item === null || item === void 0 ? void 0 : item.expire_time);
        if (!Number.isFinite(ms)) return true;
        if (ms >= now) return true;
        return now - ms <= THIRTY_DAYS_MS;
    });
    if (!selectable.length) return null;
    return selectable.find(isDeviceActive) || selectable[0] || null;
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};


/***/ }),

/***/ 38365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ isSelectableDevice; },
/* harmony export */   "MA": function() { return /* binding */ resolveDeviceSubscriptionStatus; },
/* harmony export */   "Mi": function() { return /* binding */ resolveInitialEntry; },
/* harmony export */   "Xz": function() { return /* binding */ getDeviceNotSelectableMessage; },
/* harmony export */   "cw": function() { return /* binding */ isGraceDevice; },
/* harmony export */   "dv": function() { return /* binding */ validateDeviceSelection; },
/* harmony export */   "mJ": function() { return /* binding */ isDeviceVisibleInSidebar; },
/* harmony export */   "oT": function() { return /* binding */ pickPreferredSelectableDevice; },
/* harmony export */   "q6": function() { return /* binding */ shouldEnterExpiredPurchasePage; },
/* harmony export */   "qq": function() { return /* binding */ SUBSCRIPTION_STATUS; },
/* harmony export */   "w4": function() { return /* binding */ resolveDeviceOrderId; }
/* harmony export */ });
/* unused harmony exports normalizeSubscriptionStatus, resolveSubscriptionStatus, isSelectableSubscriptionStatus, isLapsedDevice, isNoneDevice, areAllDevicesLapsed, areAllDevicesNonSelectable */
/* harmony import */ var src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96613);

/** 设备订阅状态机（与后端 user-device.subscription_status 对齐） */ const SUBSCRIPTION_STATUS = Object.freeze({
    /** 未过期 */ ACTIVE: "active",
    /** 已过期且 ≤30 天（含第 30 天，宽限期，仍可选中） */ GRACE: "grace",
    /** 已过期且 >30 天（失效，禁止选中） */ LAPSED: "lapsed",
    /**
   * 特殊态：无已支付订单，或 expire_time 为空/异常。
   * ≠ lapsed：不进「全员超 30 天」独立续费页；也不可选中。
   */ NONE: "none"
});
const STATUS_SET = new Set(Object.values(SUBSCRIPTION_STATUS));
const normalizeSubscriptionStatus = (raw)=>{
    if (raw == null || raw === "") return null;
    const status = String(raw).toLowerCase();
    return STATUS_SET.has(status) ? status : null;
};
/**
 * 由 expire_time 本地兜底（接口未回 subscription_status 时用）。
 * 无有效 expire_time → active（兼容历史无到期字段仍可进 dashboard）。
 * 服务端显式 none 时走 subscription_status 字段，不走本函数。
 */ const resolveSubscriptionStatus = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const ms = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .parseExpireMs */ .EI)(expireTime);
    if (!Number.isFinite(ms)) return SUBSCRIPTION_STATUS.ACTIVE;
    if (ms >= now) return SUBSCRIPTION_STATUS.ACTIVE;
    if (now - ms <= graceMs) return SUBSCRIPTION_STATUS.GRACE;
    return SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 优先用设备/DeviceUser 上的 subscription_status；否则用 expire_time 兜底。
 */ const resolveDeviceSubscriptionStatus = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const fromApi = normalizeSubscriptionStatus(device === null || device === void 0 ? void 0 : device.subscription_status);
    if (fromApi) return fromApi;
    var ref;
    return resolveSubscriptionStatus((ref = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .resolveDeviceExpireTime */ .ku)(device)) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
};
/** active / grace 可选中；lapsed / none 禁止成为当前选中 */ const isSelectableSubscriptionStatus = (status)=>status === SUBSCRIPTION_STATUS.ACTIVE || status === SUBSCRIPTION_STATUS.GRACE;
const isSelectableDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return isSelectableSubscriptionStatus(resolveDeviceSubscriptionStatus(device, now, graceMs));
};
const isLapsedDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.LAPSED;
};
const isGraceDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.GRACE;
};
const isNoneDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.NONE;
};
/**
 * 侧栏设备卡片是否展示：
 * - active / grace：展示
 * - none：展示（特殊：无有效已付单，但仍是绑定记录）
 * - lapsed：隐藏
 */ const isDeviceVisibleInSidebar = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) !== SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 设备关联已支付订单 ID（后端 user-device.order_id）。
 * @returns {string|number|null}
 */ const resolveDeviceOrderId = (device)=>{
    var ref, ref1;
    if (!device) return null;
    var _order_id, ref2, ref3;
    const id = (ref3 = (ref2 = (_order_id = device.order_id) !== null && _order_id !== void 0 ? _order_id : device.orderId) !== null && ref2 !== void 0 ? ref2 : device === null || device === void 0 ? void 0 : (ref = device.Order) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : device === null || device === void 0 ? void 0 : (ref1 = device.order) === null || ref1 === void 0 ? void 0 : ref1.id;
    if (id == null || id === "") return null;
    return id;
};
/**
 * 初始化/恢复选中：优先 active，其次 grace；永不返回 lapsed/none。
 * @param {Array} devices
 * @param {string} [platformType]
 */ const pickPreferredSelectableDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const selectable = scoped.filter((item)=>isSelectableDevice(item));
    if (!selectable.length) return null;
    const active = selectable.find((item)=>resolveDeviceSubscriptionStatus(item) === SUBSCRIPTION_STATUS.ACTIVE);
    return active || selectable[0] || null;
};
/**
 * 选中校验：仅 active/grace 可选。
 * @returns {{ ok: boolean, status: string, reason?: string }}
 */ const validateDeviceSelection = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    if (!device || typeof device === "object" && !Object.keys(device).length) {
        return {
            ok: true,
            status: SUBSCRIPTION_STATUS.NONE
        };
    }
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (!isSelectableSubscriptionStatus(status)) {
        return {
            ok: false,
            status,
            reason: status === SUBSCRIPTION_STATUS.LAPSED ? "lapsed_device_not_selectable" : "device_not_selectable"
        };
    }
    return {
        ok: true,
        status
    };
};
/** 侧栏不可选设备的英文提示（none ≠ 过期） */ const getDeviceNotSelectableMessage = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (status === SUBSCRIPTION_STATUS.NONE) {
        return "This package has no active subscription and cannot be selected.";
    }
    if (status === SUBSCRIPTION_STATUS.LAPSED) {
        return "This package subscription has expired and cannot be selected.";
    }
    return "This package cannot be selected.";
};
/**
 * 是否「全部设备都是 lapsed」。
 * none 不算 lapsed（有 none 混在时为 false）。
 * 只信 subscription_status（无字段时才 expire_time 兜底）。
 */ const areAllDevicesLapsed = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>isLapsedDevice(device, now, graceMs));
};
/** 无任何可选中设备（全是 lapsed / none） */ const areAllDevicesNonSelectable = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>!isSelectableDevice(device, now, graceMs));
};
/**
 * 独立续费页入口（替换旧「全设备过期超 30 天 + 无未绑单」本地推算）：
 * - 设备非空且全部 subscription_status === lapsed
 * - 且 not-bind-order 无有效未绑单
 *
 * none 不进此页。
 */ const shouldEnterExpiredPurchasePage = function() {
    let { devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    return list.length > 0 && areAllDevicesLapsed(list) && unbound.length === 0;
};
/**
 * 登录/进站：active/grace 设备 > 未绑单 > 空态
 * 「全部过期超 30 天」的判定由 userEntryGate 负责（后端状态优先），这里不参与。
 * 永不选中 lapsed/none。
 * @returns {{ type: 'device'|'unbound'|'empty', device: object|null }}
 */ const resolveInitialEntry = function() {
    let { devices =[] , validUnboundOrders =[] , preferredMode =null , preferredDevice =null  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    if (preferredDevice && isSelectableDevice(preferredDevice)) {
        return {
            type: "device",
            device: preferredDevice
        };
    }
    const preferred = pickPreferredSelectableDevice(list, preferredMode) || pickPreferredSelectableDevice(list);
    if (preferred) {
        return {
            type: "device",
            device: preferred
        };
    }
    if (unbound.length > 0) {
        return {
            type: "unbound",
            device: null
        };
    }
    return {
        type: "empty",
        device: null
    };
};


/***/ })

}]);